import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { listeningUserStateSchema } from '../schemas';

const saveListeningSessionV1DataSchemaDefinition = z.object({
  states: z.array(listeningUserStateSchema),
});

export const saveListeningSessionV1DataSchema: typeof saveListeningSessionV1DataSchemaDefinition =
  saveListeningSessionV1DataSchemaDefinition;

export type ISaveListeningSessionV1Data = z.infer<typeof saveListeningSessionV1DataSchema>;

export const saveListeningSessionV1ResponseSchema: z.ZodSchema<IAPI<ISaveListeningSessionV1Data>> =
  createApiResponseSchema(saveListeningSessionV1DataSchema) as z.ZodSchema<
    IAPI<ISaveListeningSessionV1Data>
  >;

export type ISaveListeningSessionV1Response = IAPI<ISaveListeningSessionV1Data>;
